"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1,
    rootMargin: "0px"
  });
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.2;
  return <div ref={heroRef} className="relative w-full h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/case_studies_hero_background.png)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/60 backdrop-blur-sm" />

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        {}
        <h1 className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark text-center mb-4 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        textShadow: "0 2px 8px rgba(0,0,0,0.3)"
      }}>
          Case Studies
        </h1>

        {}
        <p className={`font-sans text-lg sm:text-xl md:text-2xl text-foreground-dark/90 text-center max-w-3xl mb-8 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        textShadow: "0 1px 4px rgba(0,0,0,0.3)"
      }}>
          Discover how Nethill Limited transforms real estate investments and digital visibility through proven strategies and measurable results.
        </p>

        {}
        <div className={`transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="#case-studies">
            <Button size="lg" className="bg-secondary text-foreground-secondary px-8 py-4 text-base font-semibold rounded-md shadow-medium hover:bg-secondary-hover hover:shadow-strong hover:scale-[1.03] active:bg-secondary-active active:scale-100 transition-all duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40">
              View Success Stories
            </Button>
          </Link>
        </div>
      </div>
    </div>;
}